import { Col, Row } from "react-bootstrap";
import "./events.css";
import React, { useState } from "react";


const ReadMoreText = ({ text }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  // Split content into words
  const words = text.trim().split(/\s+/);
  const wordLimit = 17;

  // Check if content exceeds limit
  const isLong = words.length > wordLimit;

  // Get preview content
  const previewText = words.slice(0, wordLimit).join(" ");

  return (
    <div>
      <p>
        {isExpanded || !isLong
          ? text
          : previewText + "..."}
      </p>

      {isLong && (
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          style={{
            background: "none",
            border: "none",
            color: "blue",
            cursor: "pointer",
            padding: 0
          }}
        >
          {isExpanded ? "Read less" : "Read more"}
        </button>
      )}
    </div>
  );
};

function Eventshappening(props) {
  const { data } = props;

  return (
    <>

      <div className="container mt-5">

      <h2>Events & Happenings</h2>

        <div className="row">
          {data.map((item, i) => {
            return (
              (i % 2 == 0) ? (
                <div className="col-lg-6" >
                  <div className="news-card">
                    <div className="news-text">
                      <div className="news-date">
                        {item.month}<span className="news-day"> {item.year}</span>
                      </div>
                      <p className="mb-1"><b>{item.title}</b></p>
                      <ReadMoreText text={item.discription} />
                      <small>{item.month} {item.year}</small>

                    </div>
                    <div className="news-img">
                      <img src={item.image}  alt={item.title} />
                    </div>
                  </div>
                </div>)
                : (
                  <div className="col-lg-6">
                    <div className="news-card flex-row-reverse">
                      <div className="news-text text-end">
                        <div className="news-date">
                          {item.month}<span className="news-day"> {item.year}</span>
                        </div>
                        <p className="mb-1"><b>{item.title}</b></p>
                        <ReadMoreText text={item.discription} />
                        <small>{item.month}{item.year}</small>

                      </div>
                      <div className="news-img">
                        <img src={item.image} alt={item.title} />
                      </div>
                    </div>
                  </div>
                )
            )

          })}
                  </div>

      </div>

    </>
  );
}

export default Eventshappening;
